import React, { useEffect, useState } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import "../css/MainFabric.css";
import Constants from "../../../Variables/Constants";
import axios from "axios";
import { toast } from "react-toastify";

const Fabric2 = ({
  setFabric2Id,
  fabric2Id,
  setFabric2Image,
  setRectangles,
  rectangles,
  setFillImageUrl,
  mainFabricId,
  onFabricSelect,
  setBaseImageUrl,
  setKonvaImage1,
  mainFabricList,
  activeTabState,
  setActiveTabState,
  setSelectedTabData,
  selectedTabData,
  setSelectedFabric2Data,
  selectedSize,
}) => {
 
  const [hoveredItem, setHoveredItem] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredFabricList, setFilteredFabricList] = useState({});

  const keys = Object.keys(searchTerm ? filteredFabricList : mainFabricList);

  // Search functionality
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    if (value === "") {
      setFilteredFabricList({});
      const rawData = mainFabricList[activeTabState] || [];
      setSelectedTabData(rawData);
    } else {
      const filtered = {};

      // Filter through each category
      Object.keys(mainFabricList).forEach(category => {
        const filteredItems = mainFabricList[category].filter(item =>
          item.name.toLowerCase().includes(value)
        );

        if (filteredItems.length > 0) {
          filtered[category] = filteredItems;
        }
      });

      setFilteredFabricList(filtered);

      // Update selected tab data based on current active tab
      if (filtered[activeTabState]) {
        setSelectedTabData(filtered[activeTabState]);
      } else {
        // If current tab has no results, switch to first available tab
        const firstAvailableTab = Object.keys(filtered)[0];
        if (firstAvailableTab) {
          setActiveTabState(firstAvailableTab);
          setSelectedTabData(filtered[firstAvailableTab]);
        } else {
          setSelectedTabData([]);
        }
      }
    }
  };

  // Update selected tab data
  const updateSelectedTabData = () => {
    const dataSource = searchTerm ? filteredFabricList : mainFabricList;
    const rawData = dataSource[activeTabState] || [];
    setSelectedTabData(rawData);
  };

  // Update selected tab data when deps change (but NOT activeTabState to avoid delay)
  useEffect(() => {
    if (mainFabricList && Object.keys(mainFabricList).length > 0 && activeTabState) {
      updateSelectedTabData();
    }
  }, [searchTerm, mainFabricList]);

  const handleTabChange = (tabName) => {
    console.log("Secondary tab changed to:", tabName);
    setActiveTabState(tabName);
    const dataSource = searchTerm ? filteredFabricList : mainFabricList;
    const rawData = dataSource[tabName] || [];
    setSelectedTabData(rawData);
    console.log("Secondary tab data set immediately:", rawData.length, "items");
    // Capture snapshot for undo/redo
    setTimeout(() => onFabricSelect?.(), 100);
  };

  const getSecondaryFabrics = async (e, fabric_type, fabricId) => {
    // ✅ Check if Art1 exists
    const art1Rectangle = rectangles?.find((rect) => rect && rect.type === "art1");

    if (!art1Rectangle) {
      toast.error(
        "Please select Art 1 design first before choosing accent color"
      );
      return;
    }

    // ✅ Fetch accent fabric data to get its accent_price
    try {
      const { data } = await axios.get(
        `${Constants.getUrls.getSingleFabric}/${fabricId}`,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      if (data?.status === "success") {
        const accentFabricData = data?.data;
        
        // Find the accent_price for the currently selected size
        // Priority: 1. Individual fabric size_details, 2. Fabric type size_details
        let accentPrice = 0;
        if (selectedSize) {
          // First check individual fabric's size_details
          if (accentFabricData?.size_details) {
            const sizeDetail = accentFabricData.size_details.find(
              (detail) => detail.size_id === selectedSize._id
            );
            accentPrice = sizeDetail?.accent_price || 0;
          }
          
          // If not found or 0, check fabric_type's size_details
          if (accentPrice === 0 && accentFabricData?.fabric_type?.size_details) {
            const fabricTypeSizeDetail = accentFabricData.fabric_type.size_details.find(
              (detail) => detail.size_id === selectedSize._id
            );
            accentPrice = fabricTypeSizeDetail?.accent_price || 0;
          }
        }

        // Store the accent fabric data with its accent_price
        setSelectedFabric2Data({
          ...accentFabricData,
          selected_accent_price: accentPrice,
        });
      }
    } catch (error) {
      console.error("Error fetching accent fabric data:", error);
      toast.error("Failed to load accent fabric details");
    }

    // ✅ Set fabric2Id AND fillImageUrl
    setFabric2Id(fabricId);
    setFillImageUrl(e);

    // ✅ IMPORTANT: Set baseImageUrl to current Art1's src
    // This ensures flood fill uses the correct Art1 design
    setBaseImageUrl(art1Rectangle.src);

    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = e;

    img.onload = () => {
      setFabric2Image([
        {
          id: `fabric2-art1`,
          image: img,
          x: art1Rectangle.x,
          y: art1Rectangle.y,
          width: art1Rectangle.width,
          height: art1Rectangle.height,
          ref: React.createRef(),
        },
      ]);
      
      // Trigger snapshot after fabric2 is set
      setTimeout(() => onFabricSelect?.(), 100);
    };

    img.onerror = () => {
      console.error("Failed to load fabric image:", e);
    };
  };



  return (
    <>
      {/* Search Input */}
      <div className="mb-3">
        <input
          type="text"
          name="search"
          id="search-fabric-2"
          placeholder="Search fabrics by name..."
          value={searchTerm}
          onChange={handleSearch}
          className="form-control"
          style={{
            padding: '8px 12px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            width: '100%',
            fontSize: '14px'
          }}
        />
      </div>
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <div className="tab-slider-container">
          <Nav className="nav-tabs-container">
            {keys.map(
              (item, index) =>
                item !== "others" && (
                  <Nav.Item key={index} style={{ paddingBottom: "10px" }}>
                    <Nav.Link
                      eventKey={item}
                      onClick={() => handleTabChange(item)}
                      className={`nav-tab ${
                        item === activeTabState ? "active-tab" : ""
                      }`}
                    >
                      {item.replaceAll("_", " ")}
                      {/* Show count of filtered items */}
                      {searchTerm && (
                        <span className="ms-1 badge bg-secondary">
                          {(searchTerm ? filteredFabricList[item] : mainFabricList[item])?.length || 0}
                        </span>
                      )}
                    </Nav.Link>
                  </Nav.Item>
                )
            )}
          </Nav>
        </div>

        {selectedTabData && selectedTabData.length > 0 && activeTabState ? (
          <Tab.Content
            className="tab-content"
            style={{
              maxHeight: "780px",
              overflowY: "auto",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {selectedTabData.map((item, index) => (
              <Tab.Pane
                key={item._id}
                eventKey={activeTabState}
                active={activeTabState}
              >
                <div
                  className={`color-box ${
                    fabric2Id === item?._id && "explore_our_products_card"
                  }`}
                  style={{ position: "relative" }}
                  onMouseEnter={() => setHoveredItem(item._id)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <img
                    loading="lazy"
                    src={Constants.imgDomain + item.image}
                    alt={`img${index + 1}`}
                    className="color-box"
                    onClick={() => {
                      if (mainFabricId) {
                        getSecondaryFabrics(
                          `${Constants.imgDomain + item.image}`,
                          `fabric2`,
                          `${item._id}`
                        );
                        onFabricSelect(item);
                        setSelectedFabric2Data(item)
                      } else {
                        toast.error("Please select main fabric first");
                      }
                    }}
                  />

                  {hoveredItem === item._id && (
                    <div
                      style={{
                        position: "absolute",
                        top: "25px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        whiteSpace: "nowrap",
                        zIndex: 10,
                        pointerEvents: "none",
                      }}
                    >
                      {item.name || "Fabric Name"}
                    </div>
                  )}

                  {fabric2Id === item._id && (
                    <div
                      onClick={() => {
                        // ✅ When deselecting Fabric2, restore Art1's original image
                        const art1Rectangle = rectangles?.find(
                          (rect) => rect && rect.type === "art1"
                        );
                        if (art1Rectangle) {
                          setBaseImageUrl(art1Rectangle.src);
                        }

                        setFabric2Id("");
                        setFillImageUrl("");
                        setFabric2Image([]);
                        setKonvaImage1?.(null); // Clear processed image
                        setSelectedFabric2Data(null); // Clear selected fabric2 data to remove price
                      }}
                      style={{ cursor: "pointer", borderRadius: "1.5rem" }}
                      className="position-absolute bg-xx active z-3 h-100 w-100 d-flex justify-content-center align-items-center top-0 right-0"
                    >
                      <img
                        loading="lazy"
                        src="https://png.pngtree.com/png-vector/20221215/ourmid/pngtree-green-check-mark-png-image_6525691.png"
                        alt="Active"
                        style={{ objectFit: "unset", width: "30px", height: "30px" }}
                        className="p-1"
                      />
                    </div>
                  )}
                </div>
              </Tab.Pane>
            ))}
          </Tab.Content>
        ) : (
          <Tab.Content className="tab-content">
            <Tab.Pane eventKey={activeTabState} active={true}>
              <div>
                {searchTerm ?
                  "No fabric found" :
                  "No fabrics available in this category."
                }
              </div>
            </Tab.Pane>
          </Tab.Content>
        )}
      </Tab.Container>
    </>
  );
};

export default Fabric2;
